// THIS FILE IS GENERATED WHEN PUBLISHING TO NPM
// DO NOT TOUCH
export const VERSION = "0.11.0";
